// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b709c8fb","999":"f7defc75"}[chunkId] + ".chunk.js";
};